module.exports = __webpack_public_path__ + "img/Correct@2x.1caf1a7b.png";